import {
  USER_INFORMATION,
  RESET_INQUIRES,
  REQUEST_INFORMATION,
  REQUEST_PLATE,
  RESET_USER,
  PLACES_ADRESS
} from "../actions/types";

const initialState = {
  home: {
    type: null,
  },
  demande: {
    test: null,
    appointment: null,
    comment: null
  },
  achat: {
    test: null,
    appointment: null,
    financing: null,
    purchaseTime: { index: 0, label: "< 1mois" , leadName: "<1"},
    customerSeat: null,
    plate: ""
  },
  user: {},
  places: {
    adress: '',
    lat: null,
    lng: null
  },
  condition: {
    plateValid: false
  }
};

export default (state = initialState, action) => {
  var newState;
  switch (action.type) {
    case PLACES_ADRESS:
    newState = { ...state };
    newState.places[action.name] = action.data;
    return newState;

    case REQUEST_INFORMATION:
      newState = { ...state };
      newState[action.section][action.name] = action.data;
      return newState;

    case REQUEST_PLATE:
      newState = { ...state };
      newState.request["plate"] = action.data;
      newState.condition["plateValid"] = action.active;
      return newState;

    case USER_INFORMATION:
      newState = { ...state };
      newState.user[action.name] = action.data;
      return newState;

    case RESET_INQUIRES:
      newState = { ...state };
      newState.demande = {
        test: null,
        appointment: null,
        comment: null
      };
      newState.achat = {
        test: null,
        appointment: null,
        financing: null,
        purchaseTime: { index: 1, label: "3 MOIS" },
        customerSeat: null,
        plate: ""
      };
      return newState;

    case RESET_USER:
      newState = { ...state };
      newState.user= {}
      return newState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/inquires.js